import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import type { User } from '../../@types/global';
import { makeAPIRequestReactQuery } from '../../react-query/api';
import { endpoints } from '../../react-query/endpoints';

export const useRerunAi = (
  images: { imageId: string; rotation?: number; mirrorImage?: boolean }[],
  estimatedVisitId?: number,
) => {
  const queryClient = useQueryClient();
  const path = '/v2/analyze-image/rerun-analysis';
  const { isLoading, mutateAsync } = useMutation(
    [path],
    () =>
      makeAPIRequestReactQuery(path, undefined, 'POST', {
        data: {
          images,
          estimatedVisitId,
        },
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          endpoints.visits,
          endpoints.latestImages,
          endpoints.visitSummaries,
        ]);
      },
    },
  );
  return { isLoading, mutateAsync };
};

export const useRerunAiForNewCariesModel = (estimatedVisitId: number) => {
  const queryClient = useQueryClient();
  const path = `/fmx-summary/${estimatedVisitId}/caries-bins`;
  const user: User = useSelector((state: any) => state?.login?.user);

  const { isLoading, mutateAsync } = useMutation(
    [path],
    () =>
      makeAPIRequestReactQuery(path, undefined, 'POST', {
        data: {
          estimatedVisitId,
        },
        headers: {
          Org: user.primaryOrganizationId,
          Practice: user.primaryPracticeId,
        },
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          endpoints.visits,
          endpoints.latestImages,
          endpoints.visitSummaries,
        ]);
      },
    },
  );
  return { isLoading, mutateAsync };
};
